var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.stepContainer)},[_c('div',{staticClass:"w-full flex justify-center"},[_c('span',{},[_vm._v(_vm._s(_vm.getMeasureStep + 1)+" / "+_vm._s(_vm.getAreaLength))])])])}
var staticRenderFns = []

export { render, staticRenderFns }